import type { FilterOption } from 'src/redux/filter/types/Filter';

export const getFilterOptionsWithoutNullActiveCounts = (options: FilterOption[]) =>
  options.map((option) => ({ ...option, activeCount: null }));

export const getTitleFromFilterOptionUid = (filterOptionUid: string) => {
  const filterOptionTitle = filterOptionUid!.match(/filter\[(.*)\]/);
  return filterOptionTitle?.[1] ? filterOptionTitle[1].replace(/_/g, ' ') : filterOptionUid;
};
